<template>
  <div class="tab-content-box clearfix">
    <div class="left-content">
      <code-box ref="leftCode" />
    </div>
    <div class="right-content">
      <div
        ref="rightContent"
        class="right-c-c scroll_bar_beautify_ff"
      >
        <template>
          <h2 class="right-c-tit">
            {{ $t('message["44"]') }}
          </h2>
          <fields-search />
          <fields-item
            v-for="item in infoDatas"
            :key="item.id"
            :item-data="item"
          />
          <div
            v-if="Object.keys(deployDatas).length > 0"
            class="valid-code-c"
          >
            <span>{{ $t('message["1175"]') }}</span>
            <div class="valid-code-switch">
              <a-switch
                :checked="!!deployDatas.config.need_captcha"
                @change="onChange"
              />
            </div>
          </div>
        </template>
        <field-item-info :visible.sync="isShow" />
      </div>
    </div>
  </div>
</template>
<script>
import CodeBox from './CodeBox'
import FieldsSearch from './FieldsSearch'
import FieldsItem from './FieldsItem'
import FieldItemInfo from './FieldItemInfo'
import { mapState, mapMutations } from 'vuex'
import { convertHtml, getH } from '@/store/universalForm/convert'
export default {
  components: {
    CodeBox,
    FieldsSearch,
    FieldsItem,
    FieldItemInfo
  },
  data () {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapState('universalForm/form', ['infoDatas', 'styleDatas', 'formDefaultDatas', 'deployDatas'])
  },
  watch: {
    formDefaultDatas: {
      handler (val) {
        // this.styleDatas.fields_html = convertHtml(this.formDefaultDatas, this.deployDatas)
        this.setCodeHtml(convertHtml(this.formDefaultDatas, this.deployDatas))
      },
      deep: true
    },
    deployDatas: {
      handler (val) {
        // this.styleDatas.fields_html = convertHtml(this.formDefaultDatas, this.deployDatas)
        this.setCodeHtml(convertHtml(this.formDefaultDatas, this.deployDatas))
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      let $main = this.$refs.rightContent
      getH($main, 210)
    })
  },
  methods: {
    ...mapMutations('universalForm/form', ['setCodeHtml']),
    onChange (e) {
      this.deployDatas.config.need_captcha = e ? 1 : 0
    }
  }
}
</script>
<style lang="scss" scoped>
.right-c-c {
  overflow-y: auto;
  width: 570px;
  padding-right: 24px;
  .valid-code-c {
    height: 40px;
    line-height: 40px;
    background: #f5f6f7;
    position: relative;
    padding-left: 12px;
    border-top: 1px solid #ebebeb;
    .valid-code-switch {
      position: absolute;
      right: 12px;
      top: 0;
    }
  }
}
</style>
